import { integrateFeatureApps } from './csr-integrator';

integrateFeatureApps().catch(console.error);
